<template>
  <div data-name="social-bar-wrapper" :class="$style.wrapper">
    <div v-if="content_top || content_bottom" :class="$style.content">
      <div v-if="content_top" :class="$style['content-top']" v-html="content_top"></div>
      <div v-if="content_bottom" :class="$style['content-bottom']" v-html="content_bottom"></div>
    </div>
    <a :href="facebook" target="_blank" rel="nofollow" aria-label="Share on Facebook" title="Share on Facebook" :class="$style['social-container']">
      <facebook :class="[$style.icon, $style.facebook]"></facebook>
    </a>
    <a :href="twitter" target="_blank" rel="nofollow" aria-label="Tweet Why I'm Prepared" title="Tweet Why I'm Prepared" :class="$style['social-container']">
      <twitter :class="[$style.icon, $style.twitter]"></twitter>
    </a>
  </div>
</template>

<script>
import facebook from './IconFacebook.vue';
import twitter from './IconTwitter.vue';
export default {
  name: 'social-bar',
  components: { facebook, twitter },
  props: ['content_top', 'content_bottom', 'facebook', 'twitter'],
  data() {
    return {};
  },
  computed: {},
  mounted() {}
};
</script>

<style lang='scss' module>
@import '../assets/css/globals.scss';

* {
  // outline: 1px solid red;
}

.wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  margin-bottom: 20px;
  margin-top: 20px;
}

.social-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;

  height: 40px;
  width: 40px;

  margin-left: 10px;

  transition: background-color 0.3s ease-in-out;
  background-color: rgba($black, 0.1);

  border-radius: 50%;

  cursor: pointer;

  &:focus,
  &:hover {
    background-color: rgba($black, 0.2);
  }

  @include large {
    margin-left: 20px;
    height: 60px;
    width: 60px;
  }
}

.content {
  color: $white;
  line-height: 1.5;
  text-align: right;

  font-size: 12px;

  @include large {
    font-size: 14px;
  }
}

.content-top {
  display: none;

  @include large {
    display: block;
  }
}

.icon {
  display: block;
  fill: $pistachio;

  &.facebook {
    width: 8px;

    @include large {
      width: 14px;
    }
  }

  &.twitter {
    width: 15px;

    @include large {
      width: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SocialBar.vue